import React from "react";

import InquiryQuestionnaire from "../../../../base/organisms/InquiryQuestionnaire";
import { questionnaireHooks } from "./store";

const LiquidGasQuestionnaire = () => (
    <InquiryQuestionnaire
        {...{ questionnaireHooks }}
        contactPath="/fluessiggas/anfrage/"
        summaryPath="/fluessiggas/anfrage/zusammenfassung"
    />
);

export default LiquidGasQuestionnaire;
